var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cu-btn",class:_vm.plain?'plain':'bg-blue',style:('font-size:'+_vm.fontSize+'px ;'+(_vm.width>0?'width:'+_vm.width+'px;text-align:center;':'padding:0 '+_vm.paddingLr+'px;')+'height:'+_vm.height+'px;line-height:'+_vm.height+'px;'
+(_vm.color!=''?'background:'+_vm.color+';':''))},[_vm._t("default"),_vm._v(_vm._s(_vm.text)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }